import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtErr, fmtRent } from "../../lib/api";

export default function Viewings() {
  const [viewings, setViewings] = useState([]);
  const load = () => api.get("/admin/viewings").then((r) => setViewings(r.data)).catch((e) => toast.error(fmtErr(e)));
  useEffect(() => { load(); }, []);

  const update = async (id, body) => {
    try { await api.patch(`/admin/viewings/${id}`, body); load(); toast.success("Updated"); }
    catch (e) { toast.error(fmtErr(e)); }
  };

  return (
    <div data-testid="viewings-page">
      <h1 className="font-heading font-bold text-2xl tracking-tight">Viewings</h1>
      <p className="text-sm text-muted-foreground mb-6">{viewings.length} viewing requests</p>
      <div className="rounded-2xl border border-border bg-card overflow-x-auto">
        <table className="w-full text-sm min-w-[800px]">
          <thead>
            <tr className="border-b border-border text-left text-xs uppercase tracking-wider text-muted-foreground">
              <th className="px-5 py-3">Listing</th><th className="px-5 py-3">Renter</th><th className="px-5 py-3">Availability</th>
              <th className="px-5 py-3">Status</th><th className="px-5 py-3">Confirmed time</th><th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {viewings.map((v) => (
              <tr key={v.id} data-testid={`viewing-row-${v.id}`} className="border-b border-border/60 last:border-0">
                <td className="px-5 py-3">
                  <p className="font-medium">{v.listing ? `${v.listing.address_street || v.listing.neighborhood}${v.listing.unit_number ? ` #${v.listing.unit_number}` : ""}` : "—"}</p>
                  <p className="text-xs text-muted-foreground">{v.listing ? `${fmtRent(v.listing.monthly_rent)}/mo · ${v.listing.neighborhood}` : ""}</p>
                </td>
                <td className="px-5 py-3">
                  {v.lead ? <Link to={`/dashboard/leads/${v.lead.id}`} className="text-primary hover:underline font-medium">{v.lead.first_name} {v.lead.last_name}</Link> : "—"}
                  <p className="text-xs text-muted-foreground">{v.lead?.phone}</p>
                </td>
                <td className="px-5 py-3 text-xs text-muted-foreground max-w-[200px]">
                  {(v.availability || []).map((s) => `${s.date?.slice(5)} ${s.slot}`).join(" · ") || "Flexible"}
                </td>
                <td className="px-5 py-3">
                  <select data-testid={`viewing-status-${v.id}`} value={v.status} onChange={(e) => update(v.id, { status: e.target.value })} aria-label="Viewing status"
                    className="rounded-lg border border-input bg-background px-2 py-1 text-xs">
                    {["requested", "confirmed", "rescheduled", "completed", "cancelled"].map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td className="px-5 py-3">
                  <input data-testid={`viewing-time-${v.id}`} type="datetime-local" defaultValue={v.confirmed_time || ""} aria-label="Confirmed time"
                    onBlur={(e) => e.target.value && update(v.id, { confirmed_time: e.target.value, status: "confirmed" })}
                    className="rounded-lg border border-input bg-background px-2 py-1 text-xs" />
                </td>
                <td className="px-5 py-3 text-xs text-muted-foreground">{v.landlord_outreach_id ? "Outreach queued" : "No email on file"}</td>
              </tr>
            ))}
            {!viewings.length && <tr><td colSpan={6} className="px-5 py-10 text-center text-muted-foreground">No viewing requests yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
